import styled from "styled-components";

const PartnerUsersPanelStyled = styled.div`

`;

export default PartnerUsersPanelStyled;